import React from 'react';
import ReactDOM from 'react-dom';
import './bootstrap-custom.scss';
import './index.css';
import './indexless.css'
//import App from './containers/App';
import { App } from './App/App';
import { unregister } from './registerServiceWorker';
import { Router, Route } from 'react-router-dom';
import { history } from './_helpers';
// import { BrowserRouter } from 'react-router-dom'

import { Provider } from 'react-redux';
import { store } from './_helpers';

import { Amplify, Auth } from 'aws-amplify';
import config from './config';

import { awsConfig } from './aws-exports';
import { startTokenKeepAlive } from './_helpers/token-keepalive';

// setup fake backend
// import { configureFakeBackend } from './_helpers';
// configureFakeBackend();


(async function init() {
    try {
        await configureAmplify();
    } catch (e) {
        console.error("Aplify configuration failed");
    }

    startTokenKeepAlive();

    ReactDOM.render(
        <Provider store={store}>
            <Router history={history}>
                <App />
            </Router>
        </Provider>,
        document.getElementById('root')
    );

    try {
        await bootstrap();
    } catch (e) {
        console.log("bootstrap failed", e);
    }
})();

async function bootstrap() {
    try {
        await Auth.currentSession();        
    } catch (e) {
        console.log('error: ', e);
        await Auth.federatedSignIn();
    }
}

async function configureAmplify() {
    let cfg = localStorage.getItem('amplify-config');
    if (cfg) {
        cfg = JSON.parse(cfg);
    } else {
        const resp = await fetch(config.apiUrl + '/config/cognito');
        const json = await resp.json();
        cfg = json.amplify;
        localStorage.setItem('amplify-config', JSON.stringify(cfg));
    }

    Amplify.configure(cfg);
}

unregister();
//registerServiceWorker();
